import React from "react";

import supportImg2 from "../../assets/images/shapes/arrow-1.png";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import batuk from "../../assets/images/new/fav-removebg-preview.png";
import { t } from "i18next";

const Support = () => {
  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
  };
  return (
    <section

      className="cta-two position-relative text-white"
      style={{
        // backgroundImage: `url("${supportImg1}")`,
        // backgroundSize: "cover",
        backgroundPosition: "center",
        width: "100%",
        minHeight: "100px",
        display: "flex",
        alignItems: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="container">
        <div
          className="row align-items-center"
          style={{
            width: "100%",
            display: "felx",
            justifyContent: "space-between",
            margin: "0px 20px",
          }}
        >
          <div className="col-md-8">
            <div className="sec-title text-left">
              <h6
                className="sec-title__tagline bw-split-in-right"
                style={{
                  display: "flex",
                  alignItems: "left",
                  justifyContent: "start",
                }}
              >
                <img className=" tagline-img" src={batuk} alt="" />

                {t("Are you a skilled Pandit or Astrologer?")}
                {/* <span className="sec-title__tagline__border"></span>Get in Touch */}
              </h6>
              <h2
                className="sec-title__title bw-split-in-left"
                style={{ marginLeft: "7px", textAlign: "left", fontFamily: 'Bricolage Grotesque', textAlign: 'left', justifyContent: "start", display: 'flex' }}
              >
                {t("Become a Partner With Us")}
              </h2>
              <p style={{ color: 'white', fontFamily: "Bricolage Grotesque" }}>
                {t("Join Myomnamo! Get regular puja and astrology bookings, serve devotees with authentic rituals, and grow your spiritual reach. Download our app, complete your profile, and start your journey as a trusted guide today!")}
              </p>
            </div>
          </div>
          <div
            className="col-md-4 text-md-end"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div className="cta-two__button d-inline-block">
              <img
                src={supportImg2}
                alt="MyOm Namo"
                className="img-fluid me-2"
                style={{ marginRight: "10px" }}
              />
              <Link
                onClick={handleClick}
                to="/become-pandit"
                className="btn btn-light text-dark px-4 py-2 rounded-pill fw-bold"
              >
                <span>{t("Become A Partner")}</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Support;
